module.exports = __webpack_public_path__ + "img/ic_outlook.f50df19e.png";